export const sanitizeForRegExp = string => {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
};

export const caseInsensitiveIncludes = (str1 = '', str2 = '') => {
  return str1.match(new RegExp(sanitizeForRegExp(str2), 'gi'));
};
